import { Skeleton } from '@/shared/ui/skeleton'
import { cn } from '@/utils/cn'
import { HTMLAttributes } from 'react'
export type ProductNotificationInfoPendingProps = {}

export const ProductNotificationInfoPending = ({
  className,
  ...props
}: ProductNotificationInfoPendingProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4',
        className,
      )}
      {...props}
    >
      <Skeleton className="size-10 w-1/3" />
      <Skeleton className="h-10 w-full" />
    </div>
  )
}
